module.exports = __webpack_public_path__ + "static/media/default_profile.d23a2999.jpg";